import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  key: 0,
  class: "_flex _cur-p"
}
const _hoisted_3 = {
  key: 1,
  class: "_flex _cur-p"
}
const _hoisted_4 = { key: 2 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_heading = _resolveComponent("base-heading")

  return (_openBlock(), _createElementBlock("div", {
    "data-qa": `payment-group:${$props.dataQa}`
  }, [
    ($props.isCollapsible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "_tc--accent _mt-1 _ml-1 _select-none",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('toggle')))
        }, [
          ($props.isCollapsed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_base_icon, {
                  name: "chevron-down",
                  class: "_mr-1"
                }),
                _createTextVNode(" " + _toDisplayString($props.collapsedTitle), 1 /* TEXT */)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_base_icon, {
                  name: "chevron-up",
                  class: "_mr-1"
                }),
                _createTextVNode(" " + _toDisplayString($props.title), 1 /* TEXT */)
              ]))
        ]))
      : ($props.isTitleVisible)
        ? (_openBlock(), _createBlock(_component_base_heading, {
            key: 1,
            tag: "h4",
            variant: "light",
            class: "_mt-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($props.title), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
    (!$props.isCollapsible || !$props.isCollapsed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("v-if", true)
  ], 8 /* PROPS */, _hoisted_1))
}